// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"4798":"06d3147ce0b19daa","9890":"13f48537896d96bf"}[chunkId] + ".js";
};